import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './ghs-social-share.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { classMap } from 'lit/directives/class-map.js';

import { SlotController } from '../../controllers/slot-controller';
import { HorizontalAlignment } from '../../base/outline-element/utils/types';

export type IconStyleType = 'light' | 'boxes' | 'dark';

/**
 * Social Share Component
 * @element ghs-social-share
 */
@customElement('ghs-social-share')
export class GhsSharingIcons extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  slots = new SlotController(this, true);

  /**
   * Define the icon style to use.
   */
  @property({ type: String, attribute: 'icon-style' })
  iconStyle: IconStyleType;

  /**
   * Wrap icon with a rounded border.
   *   It's not available for the 'boxes' icon style.
   */
  @property({ type: Boolean, attribute: 'with-border' })
  withBorder = false;

  @property({ type: String, attribute: 'alignment', reflect: true })
  alignment: HorizontalAlignment;

  render(): TemplateResult {
    const classes = {
      'social-share__group': true,
      [`social-share__group--${this.iconStyle}`]: this.iconStyle,
      'social-share__group--with-border':
        this.iconStyle !== 'boxes' && this.withBorder,
      [`social-share__group--${this.alignment}`]: this.alignment,
    };

    return html`
      <div class="${classMap(classes)}">
        <slot></slot>
      </div>
    `;
  }
}
